export default __webpack_public_path__ + "static/media/Testes-Software-EN.58f27be2.jpg";